import React, { useEffect } from 'react'
import Logout from '../../helperFunction/Logout'
import { Link, useLocation } from 'react-router-dom'

const Sidebar = () => {
  const location = useLocation()

  useEffect(() => {
    const links = document.querySelectorAll('#layout-menu .menu-link[href]:not(.logout-link):not(.layout-menu-toggle)')
    links.forEach((link) => {
      const path = new URL(link.href).pathname
      const isExact = path === '/'
      const isActive = isExact ? location.pathname === path : location.pathname.startsWith(path)
      link.closest('.menu-item')?.classList.toggle('active', isActive)
    })
    document.body.classList.remove('layout-menu-expanded')
  }, [location.pathname])

  const toggleLayoutMenu = () => document.body.classList.toggle('layout-menu-expanded')
  const closeLayoutMenu = () => document.body.classList.remove('layout-menu-expanded')

  return (
    <>
      <aside id="layout-menu" className="layout-menu menu-vertical menu bg-menu-theme">
        <div className="app-brand demo d-flex justify-content-center">
          <Link to="/" className="app-brand-link">
            <span className="app-brand-logo demo">
              <img src="/img/logo-light.png" width="145px" className="me-2" />
            </span>
          </Link>

          <Link className="layout-menu-toggle menu-link text-large ms-auto d-block d-xl-none" onClick={closeLayoutMenu}>
            <i className="bx bx-chevron-left bx-sm align-middle"></i>
          </Link>
        </div>

        <div className="menu-inner-shadow"></div>

        <ul className="menu-inner py-1">

          <li className="menu-item">
            <Link to="/" className="menu-link">
              <i className="menu-icon tf-icons pi pi-clipboard"></i>
              <div>Dashboard</div>
            </Link>
          </li>

          <li className="menu-header small text-uppercase">
            <span className="menu-header-text">Home Layout</span>
          </li>
          <li className="menu-item">
            <Link to="/home-layout" className="menu-link">
              <i className="menu-icon tf-icons bi bi-house"></i>
              <div>Home Layout</div>
            </Link>
          </li>
          
          <li className="menu-header small text-uppercase">
            <span className="menu-header-text">Admin Users</span>
          </li>
          <li className="menu-item">
            <Link to="/admin-users" className="menu-link">
              <i className="menu-icon tf-icons bi bi-people-fill"></i>
              <div>Admin User</div>
            </Link>
          </li>

          <li className="menu-header small text-uppercase">
            <span className="menu-header-text">Banner</span>
          </li>
          <li className="menu-item">
            <Link to="/banners" className="menu-link">
              <i className="menu-icon pi pi-flag"></i>
              <div>Banners</div>
            </Link>
          </li>

          <li className="menu-header small text-uppercase">
            <span className="menu-header-text">Courses</span>
          </li>
          <li className="menu-item">
            <Link to="/category" className="menu-link">
              <i className="menu-icon tf-icons pi pi-bars"></i>
              <div>Category</div>
            </Link>
          </li>
          <li className="menu-item">
            <Link to="/courses" className="menu-link">
              <i className="menu-icon tf-icons pi pi-book"></i>
              <div>Courses</div>
            </Link>
          </li>
          <li className="menu-item">
            <Link to="/collections" className="menu-link">
              <i className="menu-icon tf-icons pi pi-book"></i>
              <div>Collection</div>
            </Link>
          </li>

          <li className="menu-header small text-uppercase">
            <span className="menu-header-text">Customers</span>
          </li>
          <li className="menu-item">
            <Link to="/customers" className="menu-link">
              <i className="menu-icon pi pi-id-card"></i>
              <div>Customers</div>
            </Link>
          </li>
          <li className="menu-item">
            <Link to="/account-deletion" className="menu-link">
              <i className="menu-icon tf-icons bi bi-person-x-fill"></i>
              <div>Account deletion</div>
            </Link>
          </li>

          <li className="menu-header small text-uppercase">
            <span className="menu-header-text">Orders</span>
          </li>
          <li className="menu-item">
            <Link to="/orders" className="menu-link">
              <i className="menu-icon pi pi-shopping-cart"></i>
              <div>Orders</div>
            </Link>
          </li>

          <li className="menu-header small text-uppercase">
            <span className="menu-header-text">Quiz</span>
          </li>
          <li className="menu-item">
            <Link to="/quiz" className="menu-link">
              <i className="menu-icon tf-icons bi bi-clipboard2"></i>
              <div>Quiz</div>
            </Link>
          </li>

          <li className="menu-header small text-uppercase">
            <span className="menu-header-text">Master</span>
          </li>
          {/* <li className="menu-item">
            <Link to="/notifications" className="menu-link">
              <i className="menu-icon bi bi-bell-fill"></i>
              <div>Notifications</div>
            </Link>
          </li> */}
          <li className="menu-item">
            <Link to="/badges" className="menu-link">
              <i className="menu-icon bi bi-person-badge-fill"></i>
              <div>Badges</div>
            </Link>
          </li>
          <li className="menu-item">
            <Link to="/business-category" className="menu-link">
              <i className="menu-icon bi bi-building"></i>
              <div>Business Category</div>
            </Link>
          </li>
          <li className="menu-item">
            <Link to="/testimonials" className="menu-link">
              <i className="menu-icon pi pi-inbox"></i>
              <div>Testimonials</div>
            </Link>
          </li>
          <li className="menu-item">
            <Link to="/faqs" className="menu-link">
              <i className="menu-icon pi pi-question-circle"></i>
              <div>FAQS</div>
            </Link>
          </li>
          <li className="menu-item">
            <Link to="/top-search" className="menu-link">
              <i className="menu-icon pi pi-search"></i>
              <div>Top Search</div>
            </Link>
          </li>
          <li className="menu-item">
            <Link to="/languages" className="menu-link">
              <i className="menu-icon pi pi-language"></i>
              <div>Languages</div>
            </Link>
          </li>

          <li className="menu-header small text-uppercase">
            <span className="menu-header-text">My Account</span>
          </li>
          <li className="menu-item">
            <Link onClick={() => Logout()} className="menu-link logout-link" >
              <i className="menu-icon tf-icons pi pi-sign-out"></i>
              <div>Logout</div>
            </Link>
          </li>

        </ul>
      </aside>

      <nav className="layout-navbar container-xxl navbar navbar-expand-xl navbar-detached align-items-center bg-navbar-theme mx-5" id="layout-navbar">
        <div className="layout-menu-toggle navbar-nav align-items-xl-center me-3 me-xl-0 d-xl-none">
          <Link className="nav-item nav-link px-0 me-xl-4" onClick={toggleLayoutMenu}>
            <i className="bx bx-menu bx-sm"></i>
          </Link>
        </div>
        <div className="navbar-nav-right d-flex align-items-center" id="navbar-collapse">
          <ul className="navbar-nav flex-row align-items-center ms-auto">
            <li className="nav-item navbar-dropdown dropdown-user dropdown">
              <Link className="nav-link dropdown-toggle hide-arrow" data-bs-toggle="dropdown">
                <div className="avatar avatar-online">
                  <img src="/img/user-profile.jpg" alt className="w-px-40 h-auto rounded-circle" />
                </div>
              </Link>
              <ul className="dropdown-menu dropdown-menu-end">
                <li>
                  <Link className="dropdown-item" to="/profile">
                    <i className="bx bx-user me-2 text-dark"></i>
                    <span className="align-middle text-dark">My Profile</span>
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" onClick={() => Logout()}>
                    <i className="bx bx-power-off me-2 text-dark"></i>
                    <span className="align-middle text-dark">Logout</span>
                  </Link>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </nav>
    </>
  )
}

export default Sidebar
